import { settings, colors } from '@dooer/react-ui-kit'
import { colorFromScore } from '../../utils'

export default {
  root: {
    boxShadow: `${settings.shadows.regular} !important`,
    '@media(max-width: 500px)': {
      boxShadow: 'none !important',
      border: 'none',
    },
  },
  content: {
    '@media(max-width: 500px)': {
      padding: 0,
    },
  },
  textarea: {
    width: '100%',
    minWidth: '100%',
    maxWidth: '100%',
    minHeight: '120px',
    maxHeight: '120px',
    borderColor: `#D4D8dA !important`, // using a darker gray to better highlight the textarea
  },
  updateCta: {
    marginLeft: settings.spacing.medium,
    border: 'none !important',
    textTransform: 'none',
  },
  previousRatingHeadingWrapper: {
    marginBottom: settings.spacing.medium,
  },
  previousRatingHeading: {
    letterSpacing: 0,
  },
  previousRatingDate: {
    letterSpacing: 0,
  },
  prevWousRatingWrapper: {
    width: '90px',
    marginBottom: settings.spacing.large,
  },
  previousRating: (value: number) => ({
    width: '90px',
    backgroundColor: colorFromScore(value),
  }),
  currentRating: (value: number, includeColors?: boolean) => ({
    width: '90px',
    marginBottom: settings.spacing.large,
    backgroundColor: includeColors ? colorFromScore(value) : colors.backgrounds.dark,
  }),
  feedbackHeading: {
    letterSpacing: 0,
  },
  cta: {
    textTransform: 'none',
  },
  error: {
    margin: `${settings.spacing.medium} 0`,
    display: 'block',
  },
}
